module.exports = {"pathContext":{"name":"ScheduleTemplateRangeInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"appointmentTypeId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"range","type":{"kind":"SCALAR","name":"Numrange","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-schedule-template-range-input.json
// module id = 1555
// module chunks = 9030065451625